import { Actions } from "../constant";

export const updatingIdle = (ip) => ({ type: Actions.UPDATING_IDLE, ip });
export const updatedIdle = (ip) => ({ type: Actions.UPDATED_IDLE, ip });
export const updatingFallback = (ip) => ({ type: Actions.UPDATING_FALLBACK, ip });
export const updatedFallback = (ip) => ({ type: Actions.UPDATED_FALLBACK, ip });
